// extracted by mini-css-extract-plugin
export default {"container":"can_container__9XsE8","text":"can_text__Bh9Tk","icon":"can_icon__s1XBY"};